module.exports = __webpack_public_path__ + "static/media/fa-regular-400.914437d6.woff2";